import { render } from "./ChatAction.vue?vue&type=template&id=f622f8c0"
import script from "./ChatAction.vue?vue&type=script&lang=js"
export * from "./ChatAction.vue?vue&type=script&lang=js"

import "./ChatAction.vue?vue&type=style&index=0&id=f622f8c0&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__